import { useIsMutating } from "@tanstack/react-query";
import { useWalletContext } from "../store";
import { useWalletApi } from "./useWalletApi";
import { BALANCE_MUTATION_KEY, useWalletBalanceMutation, } from "./useWalletBalance";
import { DETAILS_MUTATION_KEY, useWalletDetailsMutation, } from "./useWalletDetails";
export const useWalletState = () => {
    const { state: { balance, details }, } = useWalletContext();
    const { isSuccess: balanceSuccess } = useWalletBalanceMutation();
    const { isSuccess: detailsSuccess } = useWalletDetailsMutation();
    const { api, query: apiQuery, initialized: apiInitialized } = useWalletApi();
    const balanceMutations = useIsMutating([BALANCE_MUTATION_KEY]);
    const detailsMutations = useIsMutating([DETAILS_MUTATION_KEY]);
    return {
        loaded: {
            api: apiInitialized,
            balance: Boolean(balance),
            details: Boolean(details?.mainAddress),
        },
        loading: {
            api: !apiInitialized && apiQuery.status === "loading",
            balance: !balance && balanceMutations > 0,
            details: !details?.mainAddress && detailsMutations > 0,
        },
        fetchedAll: detailsSuccess && balanceSuccess && apiQuery.isSuccess,
        ready: api && Boolean(balance) && Boolean(details?.mainAddress),
    };
};
//# sourceMappingURL=useWalletState.js.map